export const T = {
  en: {
    nav: { home: "Index", contact: "Contact" },
    hero: {
      kicker: "2TProd Studios — Since day one",
      // 4 lines for masked line-by-line reveal
      line1: "Studios built on",
      line2: "ink, light",
      line3: "and stubborn",
      line4: "movement.",
      sub: "Seven divisions. One kiss. A creative house printing, wrapping, shooting and packaging what other people only sketch.",
      cta: "Meet the divisions",
      scroll: "Scroll",
    },
    marquee: "Print · Wear · Stick · Frame · Pack · Wrap · Shoot · ",
    manifesto: {
      kicker: "The Manifesto",
      chapters: [
        {
          n: "01",
          title: "The Craft",
          body: "We treat every job — a business card, a full car, a wallart, a campaign — as a piece of craft. Color-managed, hand-inspected, signed off. Nothing leaves the studio unless it would leave us proud.",
        },
        {
          n: "02",
          title: "The Kiss",
          body: "Every division carries the same mark: a lipstick kiss. It is our reminder that work made with love travels further than work made with logic. A signature you can feel.",
        },
        {
          n: "03",
          title: "The Movement",
          body: "From a real estate rider to a supercar in vinyl, from a wallart in your living room to a music video in ours — we make things that move eyes, hands and rooms. Studios in motion.",
        },
      ],
    },
    divisions: {
      kicker: "Seven Divisions",
      heading: "One house. Every surface.",
      video: "Signature film",
      videoSoon: "SIGNATURE FILM · COMING SOON",
      services: "Services",
      viewContact: "Start a project",
    },
    footer: {
      cta: "Have something wild to print, wear, wrap or shoot?",
      cta2: "Let's talk.",
      copyright: "© 2TProd Studios — All rights reserved.",
    },
    contact: {
      kicker: "Chapter · Contact",
      heading: "Tell us what you want to make.",
      sub: "One studio. Seven ways in. Fill this and a human writes back — usually the same day.",
      fields: {
        name: "Full name",
        email: "Email",
        phone: "Phone (optional)",
        company: "Company (optional)",
        help: "How can we help you?",
        heard: "Where did you hear from us?",
        message: "Tell us about the project (optional)",
      },
      helpOptions: [
        "Commercial Print (2TPrint)",
        "Custom Apparel (2TShirt)",
        "Custom Stickers (2TSticker)",
        "Wall Art (2TDeco)",
        "Custom Packaging (2TPack)",
        "Car Wrap / PPF (2TWrap)",
        "Photo & Video (2TProd)",
        "Other / not sure",
      ],
      heardOptions: [
        "Google",
        "Instagram",
        "TikTok",
        "Referral / word of mouth",
        "Event / trade show",
        "Existing client",
        "Other",
      ],
      submit: "Send it",
      sending: "Sending…",
      success: "Received. A human will reply shortly.",
      error: "Something jammed the printer. Try again?",
      back: "← Back to the studio",
    },
  },
  fr: {
    nav: { home: "Index", contact: "Contact" },
    hero: {
      kicker: "2TProd Studios — Depuis le premier jour",
      line1: "Des studios bâtis sur",
      line2: "l'encre, la lumière",
      line3: "et un mouvement",
      line4: "obstiné.",
      sub: "Sept divisions. Un baiser. Une maison créative qui imprime, habille, filme et emballe ce que les autres ne font qu'esquisser.",
      cta: "Découvrir les divisions",
      scroll: "Défile",
    },
    marquee: "Imprime · Porte · Colle · Encadre · Emballe · Habille · Filme · ",
    manifesto: {
      kicker: "Le Manifeste",
      chapters: [
        {
          n: "01",
          title: "Le Métier",
          body: "Chaque travail — carte de visite, voiture entière, œuvre murale, campagne — est traité comme une pièce d'artisanat. Colorimétrie contrôlée, inspection manuelle, signée. Rien ne quitte le studio si nous n'en sommes pas fiers.",
        },
        {
          n: "02",
          title: "Le Baiser",
          body: "Chaque division porte la même marque : un baiser rouge à lèvres. C'est notre rappel que le travail fait avec amour va plus loin que le travail fait par logique. Une signature qui se ressent.",
        },
        {
          n: "03",
          title: "Le Mouvement",
          body: "D'un panneau immobilier à une supercar en vinyle, d'une toile dans ton salon à un clip dans le nôtre — nous fabriquons des choses qui bougent les regards, les mains, les pièces. Studios en mouvement.",
        },
      ],
    },
    divisions: {
      kicker: "Sept Divisions",
      heading: "Une maison. Toutes les surfaces.",
      video: "Film signature",
      videoSoon: "FILM SIGNATURE · BIENTÔT",
      services: "Services",
      viewContact: "Démarrer un projet",
    },
    footer: {
      cta: "Un truc dingue à imprimer, porter, habiller ou filmer ?",
      cta2: "Parlons-en.",
      copyright: "© 2TProd Studios — Tous droits réservés.",
    },
    contact: {
      kicker: "Chapitre · Contact",
      heading: "Dis-nous ce que tu veux créer.",
      sub: "Un studio. Sept portes d'entrée. Remplis ceci et un humain te répond — souvent le jour même.",
      fields: {
        name: "Nom complet",
        email: "Email",
        phone: "Téléphone (optionnel)",
        company: "Société (optionnel)",
        help: "Comment peut-on t'aider ?",
        heard: "Où as-tu entendu parler de nous ?",
        message: "Parle-nous du projet (optionnel)",
      },
      helpOptions: [
        "Impression commerciale (2TPrint)",
        "Vêtements personnalisés (2TShirt)",
        "Stickers personnalisés (2TSticker)",
        "Art mural (2TDeco)",
        "Emballage personnalisé (2TPack)",
        "Covering véhicule / PPF (2TWrap)",
        "Photo & Vidéo (2TProd)",
        "Autre / je ne sais pas",
      ],
      heardOptions: [
        "Google",
        "Instagram",
        "TikTok",
        "Recommandation / bouche à oreille",
        "Événement / salon",
        "Client existant",
        "Autre",
      ],
      submit: "Envoyer",
      sending: "Envoi…",
      success: "Reçu. Un humain te répond bientôt.",
      error: "L'imprimante a bourré. On réessaie ?",
      back: "← Retour au studio",
    },
  },
};
